import { observable, action, computed, configure, runInAction } from 'mobx';
import { createContext, MouseEvent } from 'react';
import { IBogReport } from '../models/bogreport';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { EmitAndSemanticDiagnosticsBuilderProgram } from 'typescript';

configure({enforceActions: 'always'});

class BogStore {
  @observable bogList: IBogReport[]  = [];
  @observable bogSearchList: IBogReport[]  = [];
  @observable bogDisplayList: IBogReport[]  = [];
  @observable bogPrevList: IBogReport[]  = [];
  @observable technicianRegistry = new Map();
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = '';
  prevTitle = '';

  @computed get bogsByDate() {
    return this.bogDisplayList.sort(
      (a, b) => Date.parse(a.date) - Date.parse(b.date));
  }

  @computed get bogsCSV() {
    return this.bogDisplayList.map(({projectType, status, ...keepAttrs}) => keepAttrs)
  }

  @action loadBogs = async () => {   
    try {
      const bogs = await agent.ProjectBogs.report();
      runInAction('loading bogs', () => {
        this.bogList.length = 0;
        bogs.forEach(bog => {
          bog.date = bog.date.substr(0, 10);
          if ((bog.technician !== '') && !Array.isArray(bog.technician))
          { 
            let techemails = bog.technician.split(',');
            for (let i = 0; i < techemails.length; i++)
            {
              var tech = this.technicianRegistry.get(techemails[i]);
              if (tech)
              {
                var prefname = ((tech.preferredName) !== "") ? `  (${tech.preferredName})` : "";
                var techname = tech.name + prefname;
                bog.technician = techname;
              }
              else
              {
                bog.technician = techemails[i];
              }
              this.bogList.push(bog);
            }
          }
        });
        this.loadingInitial = false;
      })
    } catch (error) {
      runInAction('load Bog List error' ,() => {
        this.loadingInitial = false;
      })
      toast.error('load Bog List error');
    }
  };

  //technician
  @action loadTechnicians = async () => {
    this.loadingInitial = true;
    try {
      const employees = await agent.Employees.list();
      runInAction("loading empolyees", () => {
        this.technicianRegistry.clear();
        employees.forEach((employee) => {
            this.technicianRegistry.set(employee.email, employee);
        });    
      });
    } catch (error) {
      runInAction("load technician Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load technician Error");
    }
  };

  @action searchDate = async (startDate: string, endDate: string) => {
      if (endDate !== '')
      {
        this.bogSearchList.length = 0;
        this.bogPrevList.length = 0;
        this.bogSearchList = this.bogList.filter((item: any) =>
        Date.parse(item.date) >= Date.parse(startDate) && Date.parse(item.date) <= Date.parse(endDate));
        this.bogDisplayList = this.bogSearchList.map(object => ({ ...object }));
        this.bogPrevList = this.bogSearchList.map(object => ({ ...object }));
      }
      else
      {
        this.bogSearchList.length = 0;
        this.bogPrevList.length = 0;
        this.bogSearchList = this.bogList.filter((item: any) =>
        Date.parse(item.date) >= Date.parse(startDate));
        this.bogDisplayList = this.bogSearchList.map(object => ({ ...object }));
        this.bogPrevList = this.bogSearchList.map(object => ({ ...object }));
      }
  };

  @action searchTechnician = async (technician: string, startDate: string, endDate: string) => {
    if (startDate !== '')
    {
      if (endDate !== '')
      {
        this.bogSearchList.length = 0;
        this.bogPrevList.length = 0;
        this.bogSearchList = this.bogList.filter((item: any) => 
        item.technician.toLowerCase().includes(technician.toLowerCase()) &&
        Date.parse(item.date) >= Date.parse(startDate) && Date.parse(item.date) <= Date.parse(endDate));
        this.bogDisplayList = this.bogSearchList.map(object => ({ ...object }));
        this.bogPrevList = this.bogSearchList.map(object => ({ ...object }));
      }
      else
      {
        this.bogSearchList.length = 0;
        this.bogPrevList.length = 0;
        this.bogSearchList = this.bogList.filter((item: any) =>
        item.technician.toLowerCase().includes(technician.toLowerCase()) &&
        Date.parse(item.date) >= Date.parse(startDate));
        this.bogDisplayList = this.bogSearchList.map(object => ({ ...object }));
        this.bogPrevList = this.bogSearchList.map(object => ({ ...object }));
      }
    }
    else
    {
      this.bogSearchList.length = 0;
      this.bogPrevList.length = 0;
      this.bogSearchList = this.bogList.filter((item: any) =>
      item.technician.toLowerCase().includes(technician.toLowerCase()));
      this.bogDisplayList = this.bogSearchList.map(object => ({ ...object }));
      this.bogPrevList = this.bogSearchList.map(object => ({ ...object }));
    }
  };

  @action clearDisplay = () => {
    this.bogDisplayList.length = 0;
  };

  //Select
  @action selectBogTitle = async (title: string, text: string) => {
    let bogs = this.bogSearchList.map(object => ({ ...object }));
    let bogdisplays;
    if (title !== this.prevTitle && this.prevTitle !== '')
    {
      bogdisplays = this.bogDisplayList.map(object => ({ ...object }));
      this.bogPrevList.length = 0;
      this.bogPrevList = this.bogDisplayList.map(object => ({ ...object }));
    }
    else
    {
      bogdisplays = this.bogPrevList.map(object => ({ ...object }));
    }
    if (text !== 'ALL') {
      let selectedBogs = [] as any;
      if (title === 'projectType')
      {
        selectedBogs = bogdisplays.filter((bog) =>
        bog.projectType.toLowerCase() === text.toLowerCase()
        );
      }
      else if (title === 'company')
      {
        selectedBogs = bogdisplays.filter((bog) =>
        bog.company === text
        );
      }
      else if (title === 'technician')
      {
        selectedBogs = bogdisplays.filter((bog) =>
        bog.technician.toLowerCase() === text.toLowerCase()
        );
      }
      this.bogDisplayList.length = 0;
      this.bogDisplayList = selectedBogs.map((object: any) => ({ ...object }));
    } else {
      this.bogDisplayList.length = 0;
      this.bogDisplayList = bogs.map(object => ({ ...object }));
      this.bogPrevList.length = 0;
      this.bogPrevList = bogs.map(object => ({ ...object }));
    }
    this.prevTitle = title;
  };

  @action clearPage = () => {
    this.bogList.length = 0;
    this.bogSearchList.length = 0;
    this.bogDisplayList.length = 0;
    this.bogPrevList.length = 0;
    this.technicianRegistry.clear();
    this.prevTitle = '';
  }

}

export default createContext(new BogStore());
